import Swiper from "swiper";
import $ from "jquery";
export default function () {

    if(document.querySelector('.ec-speakers__slider-container')) {

        //const slider = document.querySelectorAll('.ec-speakers .teachers-slider');

        let countSlides = document.querySelectorAll('.ec-speakers .swiper-slide').length;

        let params = {
            //slidesPerView: 3,
            slidesPerView: 'auto',
            spaceBetween: 30,
            //loop: true,
            //centeredSlides: true,
            navigation: {
                prevEl: '.speakers__button-prev',
                nextEl: '.speakers__button-next',
            },
        };

        if(countSlides > 4) {
            params.loop = true;
        }

        new Swiper(".ec-speakers__slider-container", params);
    }

    if(document.querySelector('.ec-how-be__slider-container')) {

        let countSlides = document.querySelectorAll('.ec-how-be .swiper-slide').length;

        let params = {
            //slidesPerView: 3,
            slidesPerView: 'auto',
            spaceBetween: 30,
            //loop: true,
            //centeredSlides: true,
            navigation: {
                prevEl: '.ec-how-be__button-prev',
                nextEl: '.ec-how-be__button-next',
            },
        };

        if(countSlides > 2) {
            params.loop = true;
        }

        new Swiper(".ec-how-be__slider-container", params);
    }

    $(($) => {
        $('.ec-select').on('click', '.ec-select__head', function () {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).next().fadeOut();
            } else {
                $('.ec-select__head').removeClass('open');
                $('.ec-select__list').fadeOut();
                $(this).addClass('open');
                $(this).next().fadeIn();
            }
        });

        $('.ec-select').on('click', '.ec-select__item', function () {
            let selectBlock = $(this).parent().parent();
            let value = $(this).attr('data-value');
            $('.ec-select__head').removeClass('open');
            $(this).parent().fadeOut();
            $(this).parent().prev().text($(this).text());
            $(this).parent().prev().prev().val(value);

            selectBlock.next().find('.program__row').removeClass('active');
            selectBlock.next().find($('.program__row[data-value="' + value + '"]')).addClass('active');
        });

        $('.event-constructor .header__navigation .menu-new li').click(function (event) {

            let target = $($(this).attr('data-to'));

            if( target.length ) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 500);
            }

            $('header.header').removeClass('active');
            $('.header__burger').removeClass('active');
            $("html").removeClass("noscroll-mobile");
        });

    });

}
